// import React from 'react';
// import OtherUser from './OtherUser';
// import useGetOtherUsers from '../hooks/useGetOtherUsers';
// import { useSelector } from "react-redux";
  
// const OtherUsers = ({ users, lastUserElementRef,isSpecialView = false   }) => {
//      useGetOtherUsers();
//     const { authUser, otherUsers } = useSelector(store => store.user);
//     const isLoading = !otherUsers;

//     // Unified safe user list handling
//     const displayUsers = React.useMemo(() => {
//         const sourceUsers = Array.isArray(users) ? users : otherUsers;
//         return (Array.isArray(sourceUsers) ? sourceUsers : [])
//             .filter(user => user?._id && user.isRole !== 1);
//     }, [users, otherUsers]);

//     return (
//         <div className='overflow-auto flex-1'>
//             {isLoading ? (
//                 <p className="text-center text-gray-500 mt-4">Loading users...</p>
//             ) : displayUsers.length > 0 ? (
//                  displayUsers.map((user, index) => {
//         const isLast = index === displayUsers.length - 1;
//         return isLast && !isSpecialView ? ( // Add special view check
//           <div ref={lastUserElementRef} key={user._id}>
//             <OtherUser user={user} />
//           </div>
//         ) : (
//           <OtherUser key={user._id} user={user} />
//         );
//       })
//             ) : (
//                 <p className="text-center text-gray-500 mt-4">
//                     No users available
//                 </p>
//             )}
//         </div>
//     );
// };

// export default OtherUsers  


 import React from 'react';
import OtherUser from './OtherUser';
import useGetOtherUsers from '../hooks/useGetOtherUsers';
import { useSelector } from "react-redux";
  
const OtherUsers = ({ users, lastUserElementRef  }) => {
     useGetOtherUsers();
    const { authUser, otherUsers } = useSelector(store => store.user);
    const isLoading = !otherUsers;

    // Unified safe user list handling
    const displayUsers = React.useMemo(() => {
        const sourceUsers = Array.isArray(users) ? users : otherUsers;
        return (Array.isArray(sourceUsers) ? sourceUsers : [])
            .filter(user => user?._id && user.isRole !== 1);
    }, [users, otherUsers]);

    return (
        <div className='overflow-auto flex-1'>
            {isLoading ? (
                <p className="text-center text-gray-500 mt-4">Loading users...</p>
            ) : displayUsers.length > 0 ? (
                displayUsers.map((user, index) => 
                //     (
                //     <OtherUser key={user._id} user={user} />
                // ))
                {
                    if (displayUsers.length === index + 1) {
                        return (
                            <div ref={lastUserElementRef} key={user._id}>
                                <OtherUser user={user} />
                            </div>
                        );
                    } else {
                        return <OtherUser key={user._id} user={user} />;
                    }
                })
            ) : (
                <p className="text-center text-gray-500 mt-4">
                    No users available
                </p>
            )}
        </div>
    );
};

export default OtherUsers